import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BoxDiv } from './box';
import { calculateBMI } from './util';

const Container = styled(BoxDiv)`
  padding: 35px 40px 33px 40px;
`;

const Name = styled.h1`
  font-weight: normal;
  font-size: 29px;
  line-height: 1;
  margin: 0;
`;

const Age = styled.span`
  font-size: 25px;
  color: #ff8a5f;
`;

const Row = styled.div`
  margin: 24px 0 0 0;
  position: relative;
  font-size: 21px;
  max-width: 100%;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
`;

const LargeRow = styled(Row)`
  font-size: 25px;
`;

const BMI = styled(Age)`
  color: #f54746;
  font-size: 20px;
`;

const ItemName = styled.span`
  font-size: 25px;
  color: #666666;
  line-height: 1;
`;

const ItemValue = styled(ItemName)`
  color: #333333;
`;

const Sep = styled.div`
  display: inline-block;
  height: 25px;
  width: 0;
  border: 1px solid #22a7f0;
  background: #22a7f0;
  vertical-align: middle;
  margin: 0 27px;
  position: relative;
  top: -2px;

`;

class UserInfo extends Component {
  render() {
    const u = this.props.userinfo;
    const { bmi, text } = calculateBMI(u.height, u.weight);
    const gender = (u.gender === 2 ? '女' : '男');

    return (
      <Container>
        <Name>{u.name} <Age>({u.age}岁 {gender})</Age></Name>
        <Row>
          <ItemName>身高: </ItemName>
          <ItemValue>{u.height}厘米</ItemValue>
          <Sep />

          <ItemName>体重: </ItemName>
          <ItemValue>{u.weight}公斤</ItemValue>
          <Sep />

          <ItemName>BMI指数: </ItemName>
          <ItemValue>{Number.isNaN(bmi) ? 0 : bmi.toFixed(0)} </ItemValue>
          <BMI>({Number.isNaN(bmi) ? '无数据' : text})</BMI>
        </Row>

        <LargeRow>
          <ItemName>病史: </ItemName>
          <ItemValue>{u.medical_history && u.medical_history.length ? u.medical_history.join('、') : '无'}</ItemValue>
        </LargeRow>
      </Container>
    );
  }
}

UserInfo.propTypes = {
  userinfo: PropTypes.shape({
    name: PropTypes.string,
    age: PropTypes.number,
    gender: PropTypes.number,
    height: PropTypes.number,
    weight: PropTypes.number,
    medicalHistory: PropTypes.arrayOf(PropTypes.string),
  }),
};

UserInfo.defaultProps = {
  userinfo: {
    name: null,
    age: null,
    gender: null,
    height: null,
    weight: null,
    medicalHistory: null,
  }
};

export default UserInfo;



// WEBPACK FOOTER //
// ./src/components/user-info.jsx